/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fill-weather-wind': {
    width: 100,
    height: 100,
    viewBox: '0 0 100 100',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M65.999 52h-3a2 2 0 110-3.999h3a2 2 0 000-3.999 2 2 0 11.402-3.959c3.121.211 5.596 2.783 5.596 5.959A5.998 5.998 0 0165.999 52zm-10-3.999H34.002a2 2 0 000 3.999h21.997a6 6 0 016 6c0 3.176-2.475 5.748-5.596 5.959A2 2 0 1055.999 56H34.002a6 6 0 01-5.999-5.999c0-3.175 2.475-5.747 5.596-5.959a2.07 2.07 0 01.403-.04h21.997a2 2 0 000-4 2 2 0 11.404-3.959c3.121.211 5.596 2.783 5.596 5.959a6 6 0 01-6 5.999z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/fill-weather-wind.js